// @flow
import componentLocator from './component_locator';
import offlineHandler from './offline_handler';
import $ from 'jquery';
import jwtDecode from 'jwt-decode';

type Component = {
    id: number,
    name: string,
    body: string,
    jsc: string,
    children: Array<number>,
    rerender: boolean,
    options: ({} | string),
    extra_params: {},
    subcomponents: Array<Component>
}

export default class ComponentBuilder {
    queued: boolean;
    active: boolean;

    constructor() {
        var queued = false;
        var active = false;
    }

    getLocator() {
        return componentLocator;
    }

    execute() {
        if (this.active) return this.queued = true;
        this.active = true;
        this.buildComponents();
        this.active = false;
        if (!this.queued) return;
        this.queued = false;
        this.execute();
    }

    buildComponents() {
        let components: {[string]: Component} = {}; // Shallow clone.
        Object.assign(components, window.__componentAdapter.components);
        
        let clearedKeys = [];
        Object.keys(components).forEach(function(id: string) {
            let component: Component = components[id];
            let wrapper = document.getElementById(`wrapper_${id}`);
            if (!wrapper) return;

            this._renderComponent(wrapper, component);
            clearedKeys.push(id);

            setTimeout(() => this._createComponentObjects(component), 1);
            this._scrollToElement(window.location.href); // this needs moving.
        }, this);
        clearedKeys.forEach(function(key) {
            delete window.__componentAdapter.components[key];
        });
        this.queued = this.queued && clearedKeys.length !== 0;
    }

    _renderComponent(wrapper: HTMLElement, component: Component) {
        if (!wrapper.className.includes(component.name.replace(/_/g, '-'))) {
            let oldClass = component.name.replace('_', '-'); // Compatibility for legacy code.
            let newClass = component.name.replace(/_/g, '-');
            wrapper.className = wrapper.className
                .replace(/[^ ]*-component/, '')
                .concat(` ${component.name.replace('_', '-')}-component`)
            if (oldClass != newClass) {
                wrapper.className = wrapper.className
                    .concat(` ${component.name.replace(/_/g, '-')}-component`)
            }
            
        }

        wrapper.innerHTML = component.body;
        (component.children || []).forEach(child => {
            if($(`#wrapper_${child}`).length > 0) return;
            window.__componentAdapter.componentsWaiting -= this._countChildren(child);
        });
    }

    _createComponentObjects(component: Component) {
        this._createJavascriptClass(component);
        (component.subcomponents || []).forEach(this._createJavascriptClass);
        
        window.__componentAdapter.componentsWaiting -= 1;
        this._dispatchRenderEvent(component.id, component.name, component.options, component.extra_params);
        if (window.__componentAdapter.componentsWaiting == 0) {
            componentLocator.loaded = true;
            this._handleJavascriptOnlyComponents();
        }
    }

    _createJavascriptClass(component: Component) {
        if (!component) return;
        if (typeof(component.options) === 'string') {
            component.options = jwtDecode(component.options);
        }
        let newComponent: any = null;
        if (component.jsc) {
            newComponent = componentLocator.createComponent(component.id,
                component.name, component.options, component.extra_params, component.jsc);
        } else {
            newComponent = window.getComponent(component.id);
        }
        if (newComponent && newComponent.onLoad) newComponent.onLoad();
    }

    _handleJavascriptOnlyComponents() {
        (window.components || [])
            .filter(c => !c.controller)
            .forEach(this._createJavascriptClass);
    }

    _countChildren(componentId: number) {
        let component = window.__componentAdapter.components[componentId];
        if (!component) return 0;
        let result = component.deferred ? 0 : 1;

        component.children.forEach(child => {
            result += this._countChildren(child)
        });
        return result
    }

    _scrollToElement(location: string) {
        if (!componentLocator.loaded || !location.includes('#') || location.substr(-1) === '#') return;
        
        let $element = $(location.slice(location.indexOf('#')));
        if ($element.length > 0) {
            $element[0].scrollIntoView();
        }
    }

    _dispatchRenderEvent(id: number, name: string, options: any, extra_params: any) {
        let renderedEvent: any = new Event('ComponentRendered');
        renderedEvent.componentId = id;
        renderedEvent.componentName = name;
        renderedEvent.options = options;
        renderedEvent.extra_params = extra_params;
        document.dispatchEvent(renderedEvent);
    }
}

export function buildComponents() {
    // offlineHandler.initialize();
    const componentBuilder = new ComponentBuilder();
    window.__componentAdapter.runner = componentBuilder;
    componentBuilder.execute();
}

window.addEventListener('load', function() {
    buildComponents()
})
